import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function VolumeDownIcon(props: IconProps) {
    return <Icon {...props} iconKey={"volume_down"}/>
}
